"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionSelection = void 0;
var sessionSelection = {
    chargeSessionCode: {
        codeType: "diagnosis",
        provenance: "ICD",
        code: "Z46.82",
        units: 0,
        unitable: false,
        editable: true,
        codeIssues: [],
        hash: "undefined:Z46.82",
        evidence: [
            {
                linkable: true,
                displayable: true,
                selectionState: { active: false, hover: false, visible: false },
                featureType: "complete",
                identifier: "1d6dbdc1-48f0-40ac-aedf-23a94c70f8a6",
                fieldName: "procedure_category",
                fieldIdentifier: "undefined:Z46.82",
                meta: {
                    content: "XRAY",
                    codeType: "diagnosis",
                    provenance: "icd"
                },
                hash: "procedure_category-undefined:Z46.82"
            },
            {
                linkable: true,
                displayable: true,
                selectionState: { active: false, hover: false, visible: false },
                featureType: "complete",
                identifier: "2844e277-26f0-4427-a322-bc1bdca06283",
                fieldName: "procedure_type",
                fieldIdentifier: "undefined:Z46.82",
                meta: {
                    content: "Digital Radiography",
                    codeType: "diagnosis",
                    provenance: "icd"
                },
                hash: "procedure_type-undefined:Z46.82"
            },
            {
                linkable: true,
                displayable: true,
                selectionState: { active: false, hover: false, visible: false },
                featureType: "complete",
                identifier: "6bd046b1-47d8-42ef-885e-46ff1b1e1026",
                fieldName: "reason_for_visit",
                fieldIdentifier: "undefined:Z46.82",
                meta: null,
                hash: "raw_reasonforvisit-undefined:Z46.82"
            },
            {
                linkable: true,
                displayable: true,
                selectionState: { active: false, hover: false, visible: false },
                featureType: "complete",
                identifier: "b2c79255-2e94-42d4-86ee-fe6139254570",
                fieldName: "body_region",
                fieldIdentifier: "undefined:Z46.82",
                meta: {
                    content: "Abdomen",
                    codeType: "diagnosis",
                    provenance: "icd"
                },
                hash: "body_region-undefined:Z46.82"
            },
            {
                linkable: true,
                displayable: true,
                selectionState: { active: false, hover: false, visible: false },
                featureType: "partial",
                identifier: "2829d334-5744-43d2-8885-4ca46f2d0f30",
                fieldName: "raw_body",
                fieldIdentifier: "undefined:Z46.82",
                meta: {
                    start: 109,
                    end: 184,
                    level: "sentence",
                    content: " An enteric tube is appropriately positioned in the mid to distal stomach. ",
                    identifier: "0270bc9e-eef6-40e2-b1d2-bfb88e590701",
                    hash: "0270bc9e-eef6-40e2-b1d2-bfb88e590701",
                    codeType: "diagnosis",
                    provenance: "icd"
                },
                hash: "raw_body-undefined:Z46.82:-184"
            },
            {
                linkable: true,
                displayable: true,
                selectionState: { active: false, hover: false, visible: false },
                featureType: "partial",
                identifier: "2829d334-5744-43d2-8885-4ca46f2d0f31",
                fieldName: "raw_body",
                fieldIdentifier: "undefined:Z46.81",
                meta: {
                    start: 109,
                    end: 184,
                    level: "sentence",
                    content: " An enteric tube is appropriately positioned in the mid to distal stomach. ",
                    identifier: "0270bc9e-eef6-40e2-b1d2-bfb88e590702",
                    hash: "0270bc9e-eef6-40e2-b1d2-bfb88e590702",
                    codeType: "diagnosis",
                    provenance: "icd"
                },
                hash: "raw_body-undefined:Z46.81:-184"
            }
        ],
        description: "Encounter for fitting and adjustment of non-vascular catheter"
    },
    evidence: [
        {
            linkable: true,
            displayable: true,
            selectionState: { active: false, hover: false, visible: false },
            featureType: "complete",
            identifier: "1d6dbdc1-48f0-40ac-aedf-23a94c70f8a6",
            fieldName: "procedure_category",
            fieldIdentifier: "undefined:Z46.82",
            meta: {
                content: "XRAY",
                codeType: "diagnosis",
                provenance: "icd"
            },
            hash: "procedure_category-undefined:Z46.82"
        }
    ],
    selectionState: { active: true, hover: false, visible: true }
};
exports.sessionSelection = sessionSelection;
//# sourceMappingURL=session-selection.js.map